//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils/formatDate'
export default {
  name: 'LoanOrderList',
  $dictKeyList: [
    {
      key: 'loanOrderStatus',
      name: '贷款订单状态',
    },
    // {
    //   key: 'loanSubsidyStatus',
    //   name: '贷款订单贴息状态',
    // },
  ],
  data() {
    return {
      filterForm: {
        dateRange: [],
        applyNum: '', // 订单编号
        applyState: '', // 订单状态
        nameOrPhone: '', // 贷款客户
        subsidyState: '', // 贴息状态
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      tableData: [],

      loanStatistics: {}, // 放款统计
    }
  },
  async mounted() {
    this.getLoanStatistics()
    this.getBdOrderList()
  },
  methods: {
    /**
     * @description: 获取统计详情
     * @Author: quwandong
     * @Date: 2022-05-17 18:56:34
     */
    async getLoanStatistics() {
      try {
        const res = await this.$http.loanOrder.getLoanStatistics({
          masterId: this.$route.query.$businessId,
        })
        this.loanStatistics = res.data
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取贷款订单列表
     * @Author: quwandong
     * @Date: 2022-05-17 14:08:47
     */
    async getBdOrderList() {
      try {
        this.pagination.loading = true
        const [starTime, endTime] = this.filterForm.dateRange
        const { applyNum, applyState, nameOrPhone, subsidyState } =
          this.filterForm

        let params = {
          currentPage: this.pagination.page,
          pageSize: this.pagination.size,
          masterId: this.$route.query.$businessId,
        }
        starTime &&
          (params.starTime = formatDate(new Date(starTime), 'yyyy-MM-dd'))
        endTime &&
          (params.endTime = formatDate(new Date(endTime), 'yyyy-MM-dd'))
        applyState && (params.applyState = applyState)
        applyNum && (params.applyNum = applyNum)
        nameOrPhone && (params.nameOrPhone = nameOrPhone)
        subsidyState && (params.subsidyState = subsidyState)

        const res = await this.$http.loanOrder.getOrderlist(params)
        this.tableData = res.data.content

        if (this.pagination.page == 1) {
          this.pagination.total = res.data.recordTotal
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pagination.loading = false
      }
    },
    /**
     * @description: 条件查询
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:07
     */
    handleFilter() {
      this.pagination.page = 1
      this.getBdOrderList()
    },
    /**
     * @description: 重置查询表单
     * @param formName
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:27
     */
    handleReset() {
      this.filterForm.dateRange = []
      this.filterForm.applyNum = ''
      this.filterForm.applyState = ''
      this.filterForm.subsidyState = ''
      this.filterForm.nameOrPhone = ''
      this.$nextTick(() => {
        this.handleFilter()
      })
    },
    /**
     * @description: 点击分页
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:53
     */
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getBdOrderList()
    },
    /**
     * @description: 跳转详情页面
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-17 14:24:25
     */
    goDetail(id) {
      this.$router.push({
        path: '/cooperative/loanOrder/detail',
        query: { id },
      })
    },
    /**
     * @description: 贴息查看
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-18 10:02:56
     */
    goDiscountDetail(row) {
      const id = row.applyId
      this.$router.push({
        path: '/cooperative/loanOrder/discountDetail',
        query: { id, applyNum: row.applyNum, applyTime: row.applyTime },
      })
    },
  },
}
